import './Flows';
export var fetchWorkflowById = function (id, workflows) {
    var flows = workflows.filter(function (workflow) { return workflow.value.toUpperCase() === id.toUpperCase(); });
    return flows[0];
};
